import {useTexture} from '@react-three/drei'
import {MeshBasicMaterial} from 'three'
export default function ThreePatternPanel({cardType, cardPattern, geometry, rotation, position, cardColor, ...props}){

    if(!cardPattern) return null
    
    const texture = useTexture(cardPattern.path)
    const material = new MeshBasicMaterial({
        map:texture,
        transparent: true,
        color: cardColor.contrastHex
    })    
    
    return (
        <mesh geometry={geometry} material={material}/>
    )
}
